import { FC, useState } from "react"
import { Flex } from "antd"
import { ItemCategoryItemsListProps } from "./ItemCategoryItemsList"
import { ItemCategoryList } from "./ItemCategoryList"
import { ShowIf } from "../../../core/component"
import { ItemCategoryItemsList } from "./ItemCategoryItemsList"

export const ItemCategoryListPage: FC = () => {
  const [itemListProps, setItemListProps] = useState<ItemCategoryItemsListProps>()

  return (
    <Flex gap={16}>
      <div className="w-50">
        <ItemCategoryList
          onSelectionChange={(id, level) => setItemListProps({ [`${level.toLowerCase()}Id`]: id })}
        />
      </div>
      <Flex
        className='w-50 mt-4'
      >
        <ShowIf
          condition={!!itemListProps}
          replacement={<></>}
        >
          <ItemCategoryItemsList {...itemListProps} />
        </ShowIf>
      </Flex>
    </Flex>
  )
}